import UserManagement from './user_management'

export default {
  "user_management": UserManagement
}



// WEBPACK FOOTER //
// ./src/pages/user_management/index.js